/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// IMAGE API : PAGE BUTTONS STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
    pagebuttons: {
        flex: '0',
        width: '100%',
        paddingTop: pxToEm(8),
        '& .button': {
            width: 'auto',
            '&.name-previous': { float: 'left' },
            '&.name-next': { float: 'right' }
        }
    }
});